import { Radio } from '@mui/material'

import pixIcon from '@/presentation/assets/icons/pix.svg'

import { Container } from './styles'

interface MethodPaymentProps {
  name: string
}

export const MethodPayment: React.FC<MethodPaymentProps> = ({ name }) => {
  return (
    <Container>
      <div>
        <img src={pixIcon} alt='paymentIcon' />
        <p>{name}</p>
      </div>
      <Radio />
    </Container>
  )
}
